if (!customElements.get('hat-customizer')) {
  customElements.define(
    'hat-customizer',
    class HatCustomizer extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        const dataEl = this.querySelector('[js-hat-variants]');
        try {
          this.variants = dataEl ? JSON.parse(dataEl.textContent) : [];
        } catch (e) {
          this.variants = [];
        }

        this.colorPos = parseInt(this.dataset.colorPos, 10);
        this.linePrice = 0; 
        
        this.imageEl = this.querySelector('[js-hat-image]');
        this.priceEl = this.querySelector('[js-hat-price]');
        this.idInput = this.querySelector('.product-variant-id');
        this.atcBtn = this.querySelector('[js-atc-btn]');
        this.qtyInput = this.querySelector('[js-hat-qty]');
        
        this.lineItemId = this.querySelector('[js-hat-line-item-id]');
        this.lineItemQty = this.querySelector('[js-hat-line-item-qty]');
        this.lineItemProp = this.querySelector('[js-hat-line-item-prop]');
        this.linePriceLabels = this.querySelectorAll('[js-hat-line-price-label]');

        this.infos = Array.from(this.querySelectorAll('[js-hat-info]'))
          .map((wrap) => ({
            wrap,
            trigger: wrap.querySelector('[js-hat-info-trigger]'),
            popover: wrap.querySelector('[js-hat-info-popover]'),
          }))
          .filter((info) => info.trigger && info.popover);
        this.lines = Array.from(this.querySelectorAll('[js-hat-line]'));

        if (this.idInput) this.idInput.name = 'items[0][id]';

        this.colorSelectedEl = this.querySelector('[js-hat-color-selected]');
        this.querySelectorAll('[js-hat-color-radio]').forEach((radio) => {
          radio.addEventListener('change', () => this.updateVariant());
        });

        this.colorsWrap = this.querySelector('[js-hat-colors]');
        this.colorsToggle = this.querySelector('[js-hat-colors-toggle]');
        if (this.colorsWrap && this.colorsToggle) {
          const label = this.colorsToggle.querySelector('[js-hat-colors-toggle-label]');
          const allLabel = label ? label.textContent : '';
          const total = this.colorsWrap.querySelectorAll('[js-hat-color-radio]').length;
          this.colorsToggle.addEventListener('click', () => {
            const expanded = this.colorsWrap.classList.toggle('is-collapsed') === false;
            this.colorsToggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
            if (label) label.textContent = expanded ? 'See fewer options' : allLabel || `See all ${total} options`;
          });
        }

        if (this.qtyInput) {
          ['change', 'input'].forEach((type) => this.qtyInput.addEventListener(type, () => this.recalc()));
        }

        this.lines.forEach((line) => this.initLine(line));
        this.initSpecial();

        this.infos.forEach((info) => {
          info.trigger.addEventListener('click', () => {
            const open = info.popover.classList.contains('hidden');
            this.closePalettes();
            this.closeInfo();
            if (open) {
              info.popover.classList.remove('hidden');
              info.trigger.setAttribute('aria-expanded', 'true');
            }
          });
        });

        this.onDocumentClick = (event) => {
          this.querySelectorAll('[js-hat-color]').forEach((picker) => {
            if (picker.contains(event.target)) return;
            const palette = picker.querySelector('[js-hat-palette]');
            const trigger = picker.querySelector('[js-hat-color-trigger]');
            if (palette) palette.classList.add('hidden');
            if (trigger) trigger.setAttribute('aria-expanded', 'false');
          });
          this.infos.forEach((info) => {
            if (!info.wrap.contains(event.target)) this.closeInfo(info);
          });
        };
        document.addEventListener('click', this.onDocumentClick);

        this.onKeyup = (event) => {
          if (event.code && event.code.toUpperCase() === 'ESCAPE') {
            this.closePalettes();
            this.closeInfo();
          }
        };
        this.addEventListener('keyup', this.onKeyup);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
            if (event.source !== 'product-form') return;
            if (!this.cartEventMatches(event)) return;
            const modal = this.closest('modal-dialog');
            if (modal && modal.hasAttribute('open')) modal.hide();
          });
        }

        this.updateVariant();
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
        if (this.onDocumentClick) document.removeEventListener('click', this.onDocumentClick);
        if (this.onKeyup) this.removeEventListener('keyup', this.onKeyup);
      }

      cartEventMatches(event) {
        const myId = String(this.idInput ? this.idInput.value : '');
        if (!myId) return false;
        if (String(event.productVariantId) === myId) return true;
        const data = event.cartData;
        if (!data) return false;
        const items = Array.isArray(data.items) ? data.items : [data];
        return items.some((item) => item && (String(item.variant_id) === myId || String(item.id) === myId));
      }

      initLine(line) {
        const input = line.querySelector('[js-hat-line-input]');
        const prop = line.querySelector('[js-hat-line-prop]');
        const colorInput = line.querySelector('[js-hat-color-input]');
        const counter = line.querySelector('[js-hat-counter]');
        const trigger = line.querySelector('[js-hat-color-trigger]');
        const palette = line.querySelector('[js-hat-palette]');
        const dot = line.querySelector('[js-hat-color-dot]');
        const name = line.querySelector('[js-hat-color-name]');

        if (input) {
          input.addEventListener('input', () => {
            if (counter) counter.textContent = input.value.length;
            const hasText = input.value.trim() !== '';
            if (prop) {
              prop.value = input.value;
              prop.toggleAttribute('disabled', !hasText);
            }
            if (colorInput) colorInput.toggleAttribute('disabled', !hasText);
            this.recalc();
          });
        }

        if (trigger && palette) {
          trigger.addEventListener('click', () => {
            const wasOpen = !palette.classList.contains('hidden');
            this.closePalettes();
            this.closeInfo();
            if (!wasOpen) {
              palette.classList.remove('hidden');
              trigger.setAttribute('aria-expanded', 'true');
            }
          });

          const swatches = Array.from(palette.querySelectorAll('[data-color]'));
          swatches.forEach((swatch) => {
            swatch.addEventListener('click', () => {
              if (colorInput) colorInput.value = swatch.dataset.color;
              if (dot) dot.style.backgroundColor = swatch.dataset.swatch;
              if (name) name.textContent = swatch.dataset.color;
              swatches.forEach((s) => {
                const selected = s === swatch;
                s.classList.toggle('is-selected', selected);
                s.setAttribute('aria-pressed', selected ? 'true' : 'false');
              });
              this.closePalettes();
              trigger.focus();
            });
          });
        }
      }

      closePalettes() {
        this.querySelectorAll('[js-hat-palette]').forEach((palette) => palette.classList.add('hidden'));
        this.querySelectorAll('[js-hat-color-trigger]').forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      }

      initSpecial() {
        const input = this.querySelector('[js-hat-special-input]');
        const prop = this.querySelector('[js-hat-special-prop]');
        const counter = this.querySelector('[js-hat-special-counter]');
        if (!input) return;

        input.addEventListener('input', () => {
          if (counter) counter.textContent = input.value.length;
          const hasText = input.value.trim() !== '';
          if (prop) {
            prop.value = input.value;
            prop.toggleAttribute('disabled', !hasText);
          }
        });
      }

      closeInfo(only) {
        this.infos.forEach((info) => {
          if (only && info !== only) return;
          info.popover.classList.add('hidden');
          info.trigger.setAttribute('aria-expanded', 'false');
        });
      }

      selectedColor() {
        const checked = this.querySelector('[js-hat-color-radio]:checked');
        return checked ? checked.value : null;
      }

      filledLineCount() {
        return this.lines.filter((line) => {
          const input = line.querySelector('[js-hat-line-input]');
          return input && input.value.trim() !== '';
        }).length;
      }

      quantity() {
        const value = this.qtyInput ? parseInt(this.qtyInput.value, 10) : 1;
        return value > 0 ? value : 1;
      }

      formatMoney(cents, fallbackFormatted) {
        try {
          if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
            return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
          }
        } catch (e) {}
        
        const amount = (cents / 100).toFixed(2);
        const match = /^([^\d]*)[\d.,]+(.*)$/.exec(fallbackFormatted || '');
        return match ? `${match[1]}${amount}${match[2]}` : `$${amount}`;
      }

      recalc() {
        const qty = this.quantity();
        const filled = this.filledLineCount();
        const variant = this.currentVariant;
        
        const hasValidSurcharge = variant && variant.surcharge_id !== null;
        const surchargeActive = filled > 0 && hasValidSurcharge;

        [this.lineItemId, this.lineItemQty, this.lineItemProp].forEach((el) => {
          if (el) el.toggleAttribute('disabled', !surchargeActive);
        });
        
        if (this.lineItemQty) {
          this.lineItemQty.value = filled * qty;
        }

        if (!variant || !this.priceEl) return;

        if (typeof variant.price_cents !== 'number') {
          this.priceEl.textContent = variant.price;
          return;
        }

        const total = (variant.price_cents + (this.linePrice * filled)) * qty;
        this.priceEl.innerHTML = this.formatMoney(total, variant.price);
      }

      updateVariant() {
        const color = this.selectedColor();
        if (this.colorSelectedEl) this.colorSelectedEl.textContent = color || '';

        if (this.colorsWrap && this.colorsToggle && this.colorsWrap.classList.contains('is-collapsed')) {
          const radios = Array.from(this.colorsWrap.querySelectorAll('[js-hat-color-radio]'));
          const index = radios.findIndex((radio) => radio.checked);
          if (index >= 6) this.colorsToggle.click();
        }

        const variant = this.variants.find((v) => {
          if (this.colorPos >= 0 && color !== null && v.options[this.colorPos] !== color) return false;
          return true;
        });

        this.currentVariant = variant || null;
        const strings = window.variantStrings || {};

        if (!variant) {
          this.setButton(true, strings.unavailable || 'Unavailable');
          return;
        }

        // --- MAP SPECIFIC SURCHARGE PRODUCT TO THE NEW VARIANT ---
        if (this.lineItemId) {
          this.lineItemId.value = variant.surcharge_id || '';
        }
        this.linePrice = variant.surcharge_price || 0;
        
        // Update the "+$X.XX" labels above each input line
        if (this.linePriceLabels) {
          this.linePriceLabels.forEach(label => {
            label.textContent = variant.surcharge_price_formatted || '';
          });
        }

        if (this.idInput) {
          this.idInput.value = variant.id;
          this.idInput.toggleAttribute('disabled', !variant.available);
        }
        if (this.imageEl && variant.image) {
          this.imageEl.src = variant.image;
          this.imageEl.removeAttribute('srcset');
        }

        if (variant.available) {
          this.setButton(false, strings.addToCart || 'Add to cart');
        } else {
          this.setButton(true, strings.soldOut || 'Sold out');
        }

        this.recalc();
      }

      setButton(disabled, text) {
        if (!this.atcBtn) return;
        this.atcBtn.toggleAttribute('disabled', disabled);
        this.atcBtn.classList.toggle('is-soldout', disabled);
        const span = this.atcBtn.querySelector('span');
        if (span && text) span.textContent = text;
      }
    }
  );
}